import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setPageTitle } from '../../../modules/application/pages';
import { getMetabaseDashboardURL } from '../../../modules/metabase_dashboard';
import FacilityFilter from './facility-filter';
import Constants from '../../../constants/constants';
import './metabase-dashboard.css';

import SplitIOTreatment from '../../splitio/splitioTreatment';

import RegionalUtilizationReport from './regional-utilization/RegionalUtilizationReport';

class MetabaseDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fetchingURL: false,
      dashboardURL: '',
      failedToLoad: false,
    };

    this.props.dispatch(setPageTitle('Stats Dashboard'));
  }

  async componentDidMount() {
    this.updateMetabaseDashboard(-1);
  }

  async updateMetabaseDashboard(organizationID) {
    const { fetchingURL } = this.state;

    if (fetchingURL) {
      return;
    }

    this.setState({ fetchingURL: true });

    const dashboardURLResponse = await getMetabaseDashboardURL(organizationID);

    if (dashboardURLResponse && dashboardURLResponse.data && dashboardURLResponse.data.success) {
      this.setState({ dashboardURL: dashboardURLResponse.data.dashboard_url, fetchingURL: false });
    } else {
      this.setState({ failedToLoad: true, fetchingURL: false });
    }
  }

  printUtilizationReport() {
    return (
      <SplitIOTreatment featureName={'regional_utilization_report'} treatmentValue="on" trafficType="business-group">
        {(treatment) => {
          if (treatment === 'on') {
            return <RegionalUtilizationReport />;
          } else {
            return null;
          }
        }}
      </SplitIOTreatment>
    );
  }

  render() {
    const { dashboardURL, failedToLoad, fetchingURL } = this.state;
    const { currentUser } = this.props;

    const isBigAdmin =
      currentUser.roleLevel === Constants.REGIONAL_ADMIN_ROLE_LEVEL ||
      currentUser.roleLevel === Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL;

    let isRegional = false;
    if (currentUser.roleLevel === Constants.REGIONAL_ADMIN_ROLE_LEVEL) {
      isRegional = true;
    }

    if (failedToLoad) {
      return (
        <div>
          {isRegional && this.printUtilizationReport()}
          <div>Dashboard is presently unavailable. Please, try again later.</div>
        </div>
      );
    } else if (fetchingURL) {
      return (
        <div className="metabase_loader">
          {isRegional && this.printUtilizationReport()}
          {isBigAdmin && <FacilityFilter handle_facility_filter_change={this.updateMetabaseDashboard.bind(this)} />}
          <span>Loading dashboard...</span> <i className="fa fa-spin fa-spinner"></i>
        </div>
      );
    } else {
      return (
        <div className="metabase-container">
          {isRegional && this.printUtilizationReport()}
          {isBigAdmin && <FacilityFilter handle_facility_filter_change={this.updateMetabaseDashboard.bind(this)} />}
          <iframe title="Stats" className="metabase-iframe" src={dashboardURL} />
        </div>
      );
    }
  }
}

const withState = connect((state) => {
  const { user } = state;

  return {
    currentUser: user,
  };
});

export default withRouter(withState(MetabaseDashboard));
